import React from "react";
import { useEffect, useState } from "react";
import "./Hero.css";
import Header from "../header/Header";
import Waitlist from "../waitlist/Waitlist";

const Hero = () => {

  const launchDate = new Date("2026-05-01T10:00:00");
  const [isJoining, setIsJoining] = useState(false);

      const calculateTimeLeft =() => {
        const now = new Date();
        const difference = launchDate - now;

        let timeLeft = {};

        if (difference > 0) {
          timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
          }
        }

        return timeLeft;
    }
    
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
      setTimeLeft(calculateTimeLeft());
      console.log("minute changed");
    }, [timeLeft?.minutes]);

  return (
    <div className="Hero">
      <Header setIsJoining={setIsJoining}/>
      <div className="intro">
        <h3>African Glow with your personal skincare dermatologist</h3>
        <p>Upload a photo, detect issues like acne, hyperpigmentation, sunburn and dark spots, and receive a personalized skincare routine designed specifically for melanin-rich skin</p>
      </div>
      <div className="countdown">
        <button className="waitlist-btn" onClick={() => {setIsJoining(true)}}>Pre-Register Now</button>
        <p style={{color:"white",}}>Be among the first 1000 to register and get a 50% discount on your first 3 months</p>
        <p className="p">
          <span className="highlight">{timeLeft.days}</span> Days:{" "}
          <span className="highlight">{timeLeft.hours}</span> Hours:{" "}
          <span className="highlight">{timeLeft.minutes}</span> Minutes
          {/* <span className="highlight">58</span> Seconds */}
        </p>
      </div>
      {isJoining? <Waitlist setIsJoining={() => setIsJoining(false)}/> : ""}
    </div>
  );
};

export default Hero;
